<template>
  <label class="search-form-fieldset">
    <span class="search-form-fieldset__label">予算</span>
    <span class="search-form-fieldset__data search-form-fieldset__data--price">
      <span class="search-form__select">
        <select
          name="minPriceValue"
          v-model="minPriceValue"
        >
          <option value="0">下限を選択</option>
          <option
            v-for="(price, idx) in priceList"
            :key="`minPrice${idx}`"
            :value="price"
            v-text="`${price.toLocaleString()}円`"
          />
        </select>
      </span>
      <span class="search-form__separate">～</span>
      <span class="search-form__select">
        <select
          name="maxPriceValue"
          v-model="maxPriceValue"
        >
          <option value="0">上限を選択</option>
          <option
            v-for="(price, idx) in priceList"
            :key="`minPrice${idx}`"
            :value="price"
            v-text="`${price.toLocaleString()}円`"
          />
        </select>
      </span>
    </span>
  </label>

</template>

<script>
import {defineComponent, computed} from 'vue'
import {Util} from '../../../master.js'

export default defineComponent({
  name: 'PriceFormParts',
  props: {
    valueMin: {
      type: Number,
      default: 0,
      required: true,
    },
    valueMax: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  setup(props, context) {
    const minPriceValue = computed({
      get: () => props.valueMin,
      set: (val) => context.emit('inputMin', val),
    })
    const maxPriceValue = computed({
      get: () => props.valueMax,
      set: (val) => context.emit('inputMax', val),
    })

    const priceList = Util.PRICE_RANGE

    return {
      minPriceValue,
      maxPriceValue,
      priceList,
    }
  },
})

</script>